import { v4 } from 'uuid';
import { Buffer } from 'buffer';

/** https://github.com/taskcluster/slugid v4 */
export function slugid() {
  const bytes = v4({}, Buffer.alloc(16));
  const base64 = Buffer.from(bytes).toString('base64');
  const slug = base64
    /* Replace + with - (see RFC 4648, sec. 5) */
    .replace(/\+/g, '-')
    /* Replace / with _ (see RFC 4648, sec. 5) */
    .replace(/\//g, '_')
    /* Drop '==' padding */
    .substring(0, 22);
  return slug;
}
